export default __webpack_public_path__ + "static/pierce-931a3ecab8ff16834e7eaac8ddaf8f52.png";